import * as CL from '@design-system/component-library';
import type { ReactNode } from 'react';

import './StepContent.scss';

export interface StepContentProps {
  id: string;
  children: ReactNode;
  errorText?: string;
}

export const StepContent = ({ id, children, errorText = undefined }: StepContentProps) => {
  return (
    <div id={id} className={`of-place-order__step-content ${errorText ? 'of-place-order__step-content--error' : ''}`}>
      {children}
      {errorText && <CL.InputError>{errorText}</CL.InputError>}
    </div>
  );
};
